<template>
  <div>
    <div
      class="d-flex mb-1"
      style="font-size: 14px; color: #606266"
      v-if="ftyOrderFlowSettingCode"
    >
      <div
        class="side-frame-success"
        style="height: inherit;margin: 0;min-height: 21px;"
      ></div>
      <div>
        <el-tag
          size="mini"
          :type="
            formData.settingStatus === 'Y'
              ? 'success'
              : formData.settingStatus === 'N'
              ? 'danger'
              : ''
          "
        >
          {{ formData.v_settingStatus || 'New' }}
        </el-tag>
        <el-divider direction="vertical"></el-divider>
        <span>
          Update：{{ formData.modifyByName || '--' }} at
          {{ formData.modifyDate || '--' }}
        </span>
      </div>
    </div>

    <el-form
      ref="form"
      size="small"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      v-if="!isAdd"
    >
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_ftyOrderFlowType') || '订单流转节点类型'"
            prop="ftyOrderFlowType"
          >
            <dict-select
              v-model="formData.ftyOrderFlowType"
              url="/sys/common/dict/system"
              :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
              filterable
              clearable
              :body="ftyOrderFlowTypeParams"
              :disabled="disabled"
              style="width:100%"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item
            :label="$l('form_label_orderByDepCode') || '订单所属业务部门'"
            prop="orderByDepCode"
          >
            <dep-cascader
              size="small"
              ref="dep"
              :lastValue.sync="formData.orderByDepCode"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_userCode') || '流转节点负责人'"
            prop="userCode"
          >
            <dict-select
              v-model="formData.userCode"
              url="/master/common/dict/baseUserSelect"
              :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
              clearable
              filterable
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item :label="$l('form_label_orderCust') || '订单所属客户'">
            <dict-select
              clearable
              v-model="formData.orderCustCode"
              filterable
              url="/master/common/dict/customerSelect"
              :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
              style="width:100%"
            ></dict-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-form
      ref="form"
      size="small"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      v-if="isAdd"
    >
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_ftyOrderFlowType') || '订单流转节点类型'"
            prop="ftyOrderFlowTypeList"
          >
            <dict-select
              v-model="formData.ftyOrderFlowTypeList"
              url="/sys/common/dict/system"
              :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
              filterable
              clearable
              multiple
              :body="ftyOrderFlowTypeParams"
              :disabled="disabled"
              style="width:100%"
            ></dict-select>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_userCode') || '流转节点负责人'"
            prop="userCodeList"
          >
            <dict-select
              v-model="formData.userCodeList"
              url="/master/common/dict/baseUserSelect"
              :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
              clearable
              filterable
              multiple
            ></dict-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <ItemTable ref="itemTable" :disabled="disabled" />
      </el-row>
    </el-form>

    <el-dialog
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
      :modal-append-to-body="false"
      :modal="false"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" size="small">
          {{ $l('INDEX.btn_no_save') || '不保存' }}
        </el-button>
        <el-button @click="save()" type="primary" size="small">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import ItemTable from '../item-table'
export default {
  components: { ItemTable },
  mixins: [EditLoading],
  props: {
    disabled: { type: Boolean, default: false },
    isAdd: { type: Boolean, default: false },
    ftyOrderFlowSettingCode: { type: String, default: '' },
  },
  data() {
    return {
      formData: {},
      ftyOrderFlowTypeParams: { dictType: 'ftyOrderFlowType' },
      rules: {
        ftyOrderFlowType: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        userCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        ftyOrderFlowTypeList: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        userCodeList: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
      },
      backDialogVisible: false,
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.ftyOrderFlowSettingCode) return
      if (this.loadingOpen()) return
      this.$api
        .ftyOrderFlowSettingDetailApi({
          ftyOrderFlowSettingCode: this.ftyOrderFlowSettingCode,
        })
        .then((res) => {
          this.formData = res.body
          this.loadingClose()
        })
        .catch(() => {
          this.loadingClose()
        })
    },

    async formValidate() {
      const formResult = await validate.formValidate([this.$refs.form])
      if (!this.isAdd) return formResult
      const itemTableResult = await this.$refs.itemTable.validate()
      return formResult && itemTableResult
    },
    async save() {
      const result = await this.formValidate()
      if (!result) return
      let orderDataList = []
      if (!this.isAdd) {
        this.formData.ftyOrderFlowTypeList = [this.formData.ftyOrderFlowType]
        this.formData.userCodeList = [this.formData.userCode]
        orderDataList = [
          {
            orderByDepCode: this.formData.orderByDepCode,
            orderCustCode: this.formData.orderCustCode,
          },
        ]
      } else {
        orderDataList = this.$refs.itemTable.getTableData()
      }
      if (this.loadingOpen()) return
      const res = await this.$api
        .ftyOrderFlowSettingSaveApi({ ...this.formData, orderDataList })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      this.loadingClose()
      const { status } = res
      if (status === 203) {
        let message = res.msg.split('|')
        this.$confirm(message.join('<br />'), '数据重复,请修改后保存', {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
          showCancelButton: false,
          dangerouslyUseHTMLString: true,
          customClass: 'show_flow_setting_message',
        })
        return
      }
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })
      this.close()
      this.$emit('reload')
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.backDialogVisible = true
    },
    close() {
      this.$emit('close')
      this.backDialogVisible = false
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
}
.side-frame-warning {
  padding: 1px 5px;
  border-left: 3px solid $color-warning;
  height: 20px;
  margin-top: 3px;
}
</style>
<style lang="scss">
.show_flow_setting_message {
  width: 600px !important;
}
</style>
